// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Infinix Academy. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
